import { ref } from "vue";
import { cloudFunctions } from "@/store/cloudFunctions";
import { authStore } from "@/store/auth";
import { LessonApiPath } from "@/constants/lessonApiPaths";

export function useAssessment() {
  const isLoading = ref(false);

  const startAssessment = async (lang, courseId) => {
    isLoading.value = true;
    try {
      const response = await fetch(cloudFunctions.getLessonsApi(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + await authStore.getIdToken(),
        },
        body: JSON.stringify({
          path: LessonApiPath.ASSESSMENT,
          lang,
          courseId,
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      return data.dialogId;
    } catch (error) {
      console.error("Failed to start assessment:", error);
      throw error;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    isLoading,
    startAssessment,
  };
}
